import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
const StyledAutoGridContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-column-gap: 0.75rem;
  grid-row-gap: 0.75rem;

  @media (min-width: 37.5em) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
  }

  @media (min-width: 56.25em) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
    grid-column-gap: 1.25rem;
    grid-row-gap: 1.25rem;
  }
`;
const StyledGridContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(${props => props.$columns}, minmax(0, 1fr));
  grid-column-gap: ${props => {
    switch (props.$columns) {
        case 4:
            return '0.75rem';
        case 6:
            return '1rem';
        case 12:
            return '1.25rem';
        default:
            return '0';
    }
}};
`;
export const GridContainer = ({ children, columns, dataTestId }) => {
    if (typeof columns === 'number') {
        return (_jsx(StyledGridContainer, { "data-testid": dataTestId, "$columns": columns, children: children }));
    }
    return _jsx(StyledAutoGridContainer, { "data-testid": dataTestId, children: children });
};
//# sourceMappingURL=GridContainer.js.map